import { render, staticRenderFns } from "./AIDocToQuizGeneratingBox.vue?vue&type=template&id=9c394522&scoped=true"
import script from "./AIDocToQuizGeneratingBox.vue?vue&type=script&lang=js"
export * from "./AIDocToQuizGeneratingBox.vue?vue&type=script&lang=js"
import style0 from "./AIDocToQuizGeneratingBox.vue?vue&type=style&index=0&id=9c394522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c394522",
  null
  
)

export default component.exports